<template>
  <div class="flex h-screen w-screen flex-col lg:flex-row">
    <NavBar
      :header-service="headerService"
      :nav-module-type="NAV_MENU_TYPE.HOME"
      @handle-upgrade="togglePricingSection"
    >
      <template #pricingDialog>
        <Transition name="fade">
          <PricePlanDialog
            v-if="ifPricingSectionShown"
            @close-dialog="togglePricingSection"
          ></PricePlanDialog>
        </Transition>
      </template>
    </NavBar>
    <RouterView></RouterView>
  </div>
</template>
<script setup lang="ts">
import { useHeaderService } from '@/composables/use-header-service';
import { NavBar, NAV_MENU_TYPE } from '@eureka/shared/nav-bar';
import { ref } from 'vue';
import PricePlanDialog from '@/components/common/dialogs/PricePlanDialog.vue';

const { headerService } = useHeaderService();

const ifPricingSectionShown = ref(false);

const togglePricingSection = () => {
  ifPricingSectionShown.value = !ifPricingSectionShown.value;
};
</script>
